import React, { Component } from 'react'
import Slider from 'react-slick'
import CarouselPrevButton from './CarouselPrevButton'
import CarouselNextButton from './CarouselNextButton'

class Carousel extends Component {

	render() {
		const { className, options = {}, children } = this.props

		// default settings that could be overriden by `options`
		const settings = {
			dots: false,
			arrows: true,
			infinite: false,
			autoplay: false,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			nextArrow: <CarouselNextButton className='c-slider-arrow c-slider-arrow--next' />,
      		prevArrow: <CarouselPrevButton className='c-slider-arrow c-slider-arrow--prev' />,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		}

		// merged settings object
		const mergedSettings = {
			...settings,
			...options
		}
		return <Slider
			{ ...mergedSettings }
			className={className} >
			{children}
		</Slider>
	}
}

export default Carousel
